import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Permission } from 'src/app/constants/permission.constant';
import { IProduct } from 'src/app/models/products/product';
import { ValidationErrors } from 'src/app/models/validationErrors';
import { AuthService } from 'src/app/services/auth.service';
import { ProductsService } from 'src/app/services/products.service';
import { DeleteModalComponent } from 'src/app/components/shared/delete-modal/delete-modal.component';

@Component({
  selector: 'app-delete-action',
  templateUrl: './delete-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class DeleteActionComponent {
  @Input() product!: IProduct;
  @Output() productDeleted = new EventEmitter<void>();

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
    private productsService: ProductsService,
    private alert: MatSnackBar,
  ) {}

  onDelete(): void {
    const dialogRef = this.dialog.open(DeleteModalComponent, {
      data: {
        header: `Delete Product: ${this.product.barcode} (${this.product.reference})`,
        message: 'Are you sure you want to delete this product along with all information?',
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.productsService.deleteProduct(this.product).subscribe(
          () => {
            this.alert.open('Successfully Deleted Product', 'close', {
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              duration: 2000,
              panelClass: ['success'],
            });
            this.productDeleted.emit();
          },
          (error: any) => {
            const errorMessages: string[] = [];
            error.error.validationErrors.forEach((err: ValidationErrors) => {
              errorMessages.push(err.message);
            });
            this.alert.open('Failed To Delete', 'close', {
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
              duration: 2000,
              panelClass: ['error'],
            });
          },
        );
      }
    });
  }
}
